import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Survey.css";

const surveyQuestions = [
  {
    id: 1,
    text: "Alter:",
    type: "text"
  },
  {
    id: 2,
    text: "Geschlecht:",
    type: "single",
    options: ["Männlich", "Weiblich", "Divers"]
  },
  {
    id: 3,
    text: "Wie oft haben Sie diese Praxis bereits besucht?",
    type: "single",
    options: ["Niemals", "Häufig", "Selten"]
  },
  {
    id: 4,
    text: "Welche Art von Termin haben Sie heute?",
    type: "single",
    options: [
      "Offene Sprechstunde (kein Termin)",
      "Fixtermin bei einem bestimmten Arzt/einer bestimmten Ärztin",
      "Kurztermin (z. B. Blutdruckmessung, Rezept)",
      "Labortermin (z. B. Blutabnahme)"
    ]
  },
  {
    id: 5,
    text: "Wie oft gehen Sie zum Hausarzt?",
    type: "single",
    options: ["Regelmäßig", "Selten", "Nur wenn ich Schmerzen habe"]
  },
  {
    id: 6,
    text: "Wie empfinden Sie das Warten in dieser Praxis?",
    type: "single",
    options: [
      "Positiv (entspannt, angenehm)",
      "Neutral (kein Einfluss)",
      "Negativ (nervös, angespannt, unruhig)"
    ]
  },
  {
    id: 7,
    text: "Wie entspannt fühlen Sie sich im Moment?",
    type: "single",
    options: [
      "Sehr entspannt",
      "Entspannt",
      "Neutral",
      "Gestresst",
      "Sehr gestresst"
    ]
  },
  {
    id: 8,
    text: "Spüren Sie aktuell körperliche Unruhe?",
    type: "single",
    options: [
      "Ja, ich bin sehr unruhig",
      "Etwas Unruhe, aber nicht störend",
      "Nein, ich bin entspannt"
    ]
  },
  {
    id: 9,
    text: "Haben Sie während der Wartezeit ...",
    type: "single",
    options: [
      "Starke Angst",
      "Ein eigenartiges Gefühl der Beklemmung",
      "Vollkommene Ruhe"
    ]
  },
  {
    id: 10,
    text: "Wie wichtig ist es Ihnen, die Gründe für mögliche Wartezeitunterschiede zu kennen?",
    type: "single",
    options: [
      "Sehr wichtig",
      "Wichtig",
      "Neutral",
      "Weniger wichtig",
      "Unwichtig"
    ]
  },
  {
    id: 11,
    text: "Wenn Sie im Wartezimmer sitzen, haben Sie dann:",
    type: "single",
    options: [
      "Feuchte Hände",
      "Manchmal feuchte Hände",
      "Nie feuchte Hände"
    ]
  },
  {
    id: 12,
    text: "Wie lange erwarten Sie heute zu warten? (in Minuten)",
    type: "text"
  },
  {
    id: 13,
    text: "Wie gut wurden Sie über die voraussichtliche Wartezeit und den Ablauf informiert?",
    type: "single",
    options: [
      "Sehr gut",
      "Gut",
      "Neutral",
      "Schlecht",
      "Sehr schlecht"
    ]
  },
  {
    id: 14,
    text: "Wie haben Sie Ihren Termin vereinbart?",
    type: "single",
    options: [
      "Telefonisch",
      "Online",
      "Vor Ort",
      "Ohne Termin (offene Sprechstunde)"
    ]
  },
  {
    id: 15,
    text: "Wie viele Patienten, die vor Ihnen behandelt werden, ertragen Sie im Höchstfall?",
    type: "single",
    options: ["2", "4", "6", "10", "20"]
  },
  {
    id: 16,
    text: "Ist es Ihnen angenehm, wenn das Wartezimmer leer ist?",
    type: "single",
    options: [
      "Sehr angenehm",
      "Nicht besonders angenehm",
      "Ausgesprochen unangenehm",
      "Keine Meinung"
    ]
  },
  {
    id: 17,
    text: "Was machen Sie aktuell während der Wartezeit im Wartezimmer? (Mehrfachantwort möglich)",
    type: "multiple",
    options: [
      "Ich lese Zeitschriften oder Bücher",
      "Ich nutze mein Smartphone",
      "Ich sehe mir das Praxis-TV an",
      "Ich unterhalte mich mit anderen Patienten",
      "Ich entspanne mich oder tue nichts Bestimmtes",
      "Sonstiges"
    ]
  },
  {
    id: 18,
    text: "Nutzen Sie digitale Unterhaltungsmöglichkeiten während der Wartezeit?",
    type: "single",
    options: [
      "Ja ",
      "Nein"
    ]
  },
  {
    id: 19,
    text: "Falls nein, warum nicht?",
    type: "single",
    options: [
      "Ich wusste nicht, dass es solche Möglichkeiten gibt",
      "Ich habe sie ausprobiert, fand sie aber uninteressant",
      "Ich bin generell nicht daran interessiert",
      "Ich nutze sie"

    ]
  },
  {
    id: 20,
    text: "Falls ja, welche digitalen Unterhaltungsmöglichkeiten nutzen Sie am häufigsten? (Mehrfachantwort möglich)",
    type: "multiple",
    options: [
      "Spiele",
      "Quizfragen",
      "Gesundheitsinformationen",
      "Unterhaltung (Videos, Musik, Podcasts, Soziale Medien)",
      "Sonstiges"
    ]
  },
  {
    id: 21,
    text: "Wie hilfreich empfinden Sie digitale Unterhaltungsmöglichkeiten?",
    type: "single",
    options: [
      "Sehr hilfreich",
      "Hilfreich",
      "Neutral",
      "Wenig hilfreich",
      "Überhaupt nicht hilfreich"
    ]
  },
  {
    id: 22,
    text: "Spiel starten",
    type: "final"
  }
];

function Survey() {
  const [step, setStep] = useState(1); // Schritt 1: Spielername erfassen, Schritt 2: Umfrage
  const [username, setUsername] = useState("");
  const [currentQ, setCurrentQ] = useState(0);
  const [answers, setAnswers] = useState({});
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  // Schritt 1: Spielername prüfen (über Endpoint checkUsername)
  const [isAvailable, setIsAvailable] = useState(true);
  useEffect(() => {
    if (username.trim()) {
      axios
        .get("/api/checkUsername", { params: { username } })
        .then((res) => setIsAvailable(res.data.available))
        .catch((error) => {
          console.error("Fehler beim Prüfen des Namens:", error);
          setIsAvailable(true);
        });
    } else {
      setIsAvailable(true);
    }
  }, [username]);

  const handleAnswer = (answer) => {
    const key = `q${surveyQuestions[currentQ].id}`;
    setAnswers({ ...answers, [key]: answer });
  };

  const handleMultiple = (option) => {
    const key = `q${surveyQuestions[currentQ].id}`;
    let current = answers[key] || [];
    if (current.includes(option)) {
      current = current.filter((a) => a !== option);
    } else {
      current = [...current, option];
    }
    setAnswers({ ...answers, [key]: current });
  };

  const nextQuestion = () => {
    const q = surveyQuestions[currentQ];
    const key = `q${q.id}`;
    if (
      (q.type === "text" && (!answers[key] || answers[key].trim() === "")) ||
      (q.type === "multiple" && (!answers[key] || answers[key].length === 0)) ||
      (q.type === "single" && answers[key] === undefined)
    ) {
      setMessage("Bitte geben Sie eine Antwort ein.");
      return;
    }
    setMessage("");
    setCurrentQ(currentQ + 1);
  };

  const handleSubmit = () => {
    if (!username.trim()) {
      setMessage("Fehler: Bitte geben Sie einen Spielernamen ein.");
      return;
    }
    // Prüfe, ob alle Fragen beantwortet wurden
    if (Object.keys(answers).length < surveyQuestions.length - 1) {
      setMessage("Bitte beantworten Sie alle Fragen.");
      return;
    }
    axios
      .post("/api/users", {
        username: username,
        ...answers
      })
      .then(() => {
        localStorage.setItem("username", username);
        navigate("/memory");
      })
      .catch((error) => {
        console.error("Fehler beim Absenden der Umfrage:", error);
        setMessage(
          "Fehler: " +
            (error.response?.data?.error || error.message)
        );
      });
  };

  if (step === 1) {
    return (
      <div className="survey-container">
        <div className="fixed-header">
          <h1 className="survey-title">Spielername</h1>
        </div>
        <div className="survey-content">
          <div className="name-input-container">
            <p>Bitte geben Sie Ihren Spielernamen ein:</p>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Spielername"
            />
            {!isAvailable && (
              <p className="availability-message">
                Dieser Spielername ist bereits vergeben.
              </p>
            )}
          </div>
          <button
            className="next-button"
            onClick={() => {
              if (!username.trim()) {
                setMessage("Bitte geben Sie einen Spielernamen ein.");
                return;
              }
              if (!isAvailable) {
                setMessage("Dieser Spielername ist bereits vergeben.");
                return;
              }
              setMessage("");
              setStep(2);
            }}
          >
            Weiter
          </button>
          {message && <p className="message">{message}</p>}
        </div>
      </div>
    );
  }

  // Schritt 2: Umfragefragen beantworten
  return (
    <div className="survey-container">
      <div className="fixed-header">
        <h1 className="survey-title">Erste Umfrage</h1>
        <div className="progress-bar-container">
          <div
            className="progress-bar"
            style={{
              width: `${(currentQ / (surveyQuestions.length - 1)) * 100}%`
            }}
          ></div>
          <div className="progress-label">
            {currentQ + 1}/{surveyQuestions.length}
          </div>
        </div>
      </div>
      <div className="survey-content">
        <div className="question-container">
          <p className="question-text">
            {surveyQuestions[currentQ].text}
          </p>
          {surveyQuestions[currentQ].type === "text" ? (
            <div className="text-answer">
              <input
                type="text"
                value={answers[`q${surveyQuestions[currentQ].id}`] || ""}
                onChange={(e) =>
                  setAnswers({
                    ...answers,
                    [`q${surveyQuestions[currentQ].id}`]:
                      e.target.value
                  })
                }
                placeholder="Ihre Antwort"
              />
            </div>
          ) : surveyQuestions[currentQ].type === "single" ? (
            <div className="options">
              {surveyQuestions[currentQ].options.map((option, idx) => (
                <button
                  key={idx}
                  className="option-button"
                  onClick={() => {
                    handleAnswer(option);
                    nextQuestion();
                  }}
                >
                  {option}
                </button>
              ))}
            </div>
          ) : surveyQuestions[currentQ].type === "multiple" ? (
            <div className="options">
              {surveyQuestions[currentQ].options.map((option, idx) => (
                <label key={idx} className="option-label">
                  <input
                    type="checkbox"
                    checked={
                      answers[`q${surveyQuestions[currentQ].id}`]
                        ? answers[`q${surveyQuestions[currentQ].id}`].includes(
                            option
                          )
                        : false
                    }
                    onChange={() => handleMultiple(option)}
                  />
                  {option}
                </label>
              ))}
              <button className="next-button" onClick={nextQuestion}>
                Weiter
              </button>
            </div>
          ) : surveyQuestions[currentQ].type === "final" ? (
            <div className="final-step">
              <button className="final-button" onClick={handleSubmit}>
                Spiel starten
              </button>
            </div>
          ) : null}
        </div>
        {currentQ < surveyQuestions.length - 1 &&
          surveyQuestions[currentQ].type !== "final" &&
          surveyQuestions[currentQ].type !== "multiple" && (
            <div className="navigation">
              <button
                className="next-button"
                onClick={nextQuestion}
                disabled={
                  answers[`q${surveyQuestions[currentQ].id}`] === undefined ||
                  (surveyQuestions[currentQ].type === "multiple" &&
                    answers[`q${surveyQuestions[currentQ].id}`].length === 0)
                }
              >
                Weiter
              </button>
            </div>
          )}
        {message && <p className="message">{message}</p>}
      </div>
    </div>
  );
}

export default Survey;